export function isStringNullOrTrimEmpty(s: string | undefined | null): boolean {
    return !s || s.trim().length === 0;
}

export function isStringNullOrEmpty(s: string | undefined | null): boolean {
    return !s || s.length === 0;
}
